import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    testimonialCard: {
        backgroundColor: "#ffffff",
        height: "250px",
        color: "#333333",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        padding: "20px",
        marginBottom: "20px",
        '@media screen and (max-width: 1200px)': {
            height: "unset",
        }
    },
    testimonialText: {
        fontSize: "16px",
        lineHeight: "1.5",
        marginBottom: "10px",
    },
    testimonialAuthor: {
        fontWeight: "bold",
        fontSize: "14px",
    },
});

function TextTestimonial({ text, author }) {
    const classes = useStyles();

    return (
        <div className={classes.testimonialCard}>
            <p className={classes.testimonialText}>{<q>{text}</q>}</p>
            <p className={classes.testimonialAuthor}>- {author}</p>
        </div>
    );
}

export default TextTestimonial;
